import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsCreatedSurveyBreakupList from "../created-list-inner-pages/tms-sm-ral-survey-breakup-list";
import TmsSurveyNoBreakup from "../creation-inner-pages/tms-survey-no-breakup";
const LandSurveyBreakupIndex = () => {
  const [visible, setVisible] = useState(false);

  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New Survey Breakup
        </Button>
      </Row>
      <br />
      {!visible && <TmsCreatedSurveyBreakupList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"Survey Breakup Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsSurveyNoBreakup setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default LandSurveyBreakupIndex;
